<mat-icon *ngIf="isActive && config?.iconType === 1"
          class="bool-icon-renderer"
          [svgIcon]="config?.icon"
          matTooltipShowDelay="500"
          [matTooltip]="config?.tooltip | translate"></mat-icon>
<mat-icon *ngIf="isActive && (!config?.iconType || config?.iconType === 0)"
          class="bool-icon-renderer"
          matTooltipShowDelay="500"
          [matTooltip]="config?.tooltip | translate">{{config?.icon}}</mat-icon>
<mat-icon *ngIf="isActive && config?.iconType === 2" fontSet="estensa-icons"
          class="bool-icon-renderer"
          matTooltipShowDelay="500"
          [matTooltip]="config?.tooltip | translate">{{config?.icon}}</mat-icon>


